import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimerDefault01 = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.08301 1.41699H9.91634",
			stroke: "#71717A",
			strokeWidth: 1.59375,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 9.91699L10.625 7.79199",
			stroke: "#71717A",
			strokeWidth: 1.59375,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.49967 15.5833C11.6293 15.5833 14.1663 13.0463 14.1663 9.91667C14.1663 6.78705 11.6293 4.25 8.49967 4.25C5.37006 4.25 2.83301 6.78705 2.83301 9.91667C2.83301 13.0463 5.37006 15.5833 8.49967 15.5833Z",
			stroke: "#71717A",
			strokeWidth: 1.59375,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgTimerDefault01);
export default ForwardRef;
